import classNames from 'classnames';
import { PREVENT_BLUR_ATTRIBUTE } from 'modules/Lexical/Plugins/BlurControlPlugin';
import React, { PropsWithChildren } from 'react';
import scssVariables from 'styles/variables.scss';
import Icon from 'components/Icon';
import { NAMESPACE } from 'components/Toolbar/constants';
import { intlGet } from 'utils/intlGet';
import { ControlState } from './constants';
import { ControlProps } from './models';
import styles from './styles.module.scss';

const Control: React.FunctionComponent<PropsWithChildren<ControlProps>> = (props) => {
  const {
    children,
    className,
    controlRef,
    controlState = ControlState, // TODO: get rid of controlState, use disabled prop only
    disableHover = false,
    disabled: isDisabled = false,
    onToggle,
    preventBlur = true,
    size = 'badge',
    state,
    title,
    toggleControl = false,
    tooltipEnabled = true,
    type,
    iconTooltipClassName,
    dataTestId = `${title}-control`,
  } = props;
  const onMouseDown = (event: React.MouseEvent): void => {
    if (preventBlur) {
      event.preventDefault();
    }
  };
  const disabled = isDisabled || controlState.DISABLED === state;

  return (
    <div
      className={classNames(styles.Control, className, { [styles.disabled]: disabled })}
      data-title={`${title}@${NAMESPACE}`}
      data-testid={dataTestId}
      ref={controlRef}
      onClick={toggleControl || !type ? onToggle : undefined}
      onMouseDown={onMouseDown}
      {...{ [PREVENT_BLUR_ATTRIBUTE]: true }}
    >
      {
        type &&
        <Icon
          color={state}
          disableHover={disableHover}
          isDisabled={disabled}
          disableColor={scssVariables.mediumGrey} // TODO: Create icon color enum and use it here
          hoverColor="primary-hover"
          hoverTooltipText={tooltipEnabled ? intlGet('EditorToolbar.Tooltip', title) : ''}
          onClick={!toggleControl ? onToggle : undefined}
          size={size}
          type={type}
          iconTooltipClassName={iconTooltipClassName}
          dataTestId={dataTestId}
        />
      }
      {children}
    </div>
  );
};

export default React.forwardRef<HTMLDivElement, React.PropsWithChildren<ControlProps>>((props, ref) => (
  <Control controlRef={ref} {...props}>
    {props.children}
  </Control>
));
